import { api, responseErrorCheck, TmrBaseResource } from 'stylewhere/api'
import { Ticket } from './types'

export class Tickets extends TmrBaseResource {
  static endpoint = 'api/v1/ticket'

  static create(ticket: Ticket): Promise<void> {
    return api.post(`${this.endpoint}/open`, ticket).then(responseErrorCheck)
  }
}
